exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.avatar-and-name {\n  justify-content: flex-start !important;\n}\n.sender-text{\n  margin: 0;\n  flex: 1;\n  overflow: hidden;\n  white-space: nowrap !important;\n  text-overflow: ellipsis;\n}\n", ""]);

// exports
